import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import { FilterPicker, Checkbox, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export function VisibleColumnsPicker(props) {
    var _props_title, _props_type;
    const { fixedColumns, testId, visibleColumns, onApply } = props;
    const { t: texts } = useLocaleKeys('components.visibleColumnsPicker');
    const [selectedColumns, setSelectedColumns] = useState(visibleColumns);
    const numSelectedColumns = useMemo(()=>Object.values(selectedColumns).filter((value)=>value).length - Object.values(fixedColumns !== null && fixedColumns !== void 0 ? fixedColumns : {}).filter((value)=>value).length, [
        selectedColumns,
        fixedColumns
    ]);
    const selectAll = useMemo(()=>Object.values(selectedColumns).every((value)=>value), [
        selectedColumns
    ]);
    return /*#__PURE__*/ _jsxs(FilterPicker, {
        testId: "".concat(testId, "-column-selector"),
        label: numSelectedColumns > 0 ? "".concat(numSelectedColumns, " columns selected") : 'None selected',
        title: props.type === 'button' ? (_props_title = props.title) !== null && _props_title !== void 0 ? _props_title : 'Additional columns' : 'Additional columns',
        highlightTrigger: false,
        onApply: ()=>onApply(selectedColumns),
        onClose: ()=>{},
        type: (_props_type = props.type) !== null && _props_type !== void 0 ? _props_type : 'chip',
        prefixIcon: props.type === 'button' ? props.prefixIcon : undefined,
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                checked: selectAll,
                onChange: ()=>{
                    setSelectedColumns(Object.fromEntries(Object.entries(selectedColumns).map((param)=>{
                        let [name] = param;
                        var _ref;
                        return [
                            name,
                            (_ref = fixedColumns === null || fixedColumns === void 0 ? void 0 : fixedColumns[name]) !== null && _ref !== void 0 ? _ref : !selectAll
                        ];
                    })));
                },
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph1",
                    children: texts.selectAll()
                })
            }),
            Object.entries(selectedColumns).map((param)=>{
                let [name, selected] = param;
                return /*#__PURE__*/ _jsx(Checkbox, {
                    name: name,
                    disabled: fixedColumns === null || fixedColumns === void 0 ? void 0 : fixedColumns[name],
                    testId: "".concat(testId, "-column-picker-").concat(name.toLowerCase()),
                    checked: !!selected,
                    onChange: ()=>{
                        setSelectedColumns(_object_spread_props(_object_spread({}, selectedColumns), {
                            [name]: !selected
                        }));
                    },
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        children: name
                    })
                }, name);
            })
        ]
    });
}
